(function(angular, _) {
    'use strict';

    angular.module('wtApp.dataService')
        .factory('WtBookmarkAnalysis', ['WtAnalysis', function(WtAnalysis) {
            /**
             * @ngdoc service
             * @name WtBookmarkAnalysis
             * @description Custom analysis constructor for bookmarked analyses
             */
            return class WtBookmarkAnalysis extends WtAnalysis {
                constructor() {
                    super(...arguments);

                    /**
                     * The hard coded path send when tracking bookmark pages
                     * @type {string}
                     * @private
                     */
                    this.menuPath_ = 'bookmark';

                    // Adds older browsers support (IE < 11)
                    this.constructor = this.constructor || WtBookmarkAnalysis;
                }

                /**
                 * @ngdoc method
                 * @name WtBookmarkAnalysis.validate
                 * @description Provides a utility method to validate a configuration object if it is a valid bookmark analysis
                 * @param {Object} config The analysis configuration
                 * @throws Error
                 */
                static validate(config) {
                    super.validate(config);

                    if (!_.hasIn(config, 'customAnalysis') || !config.customAnalysis) {
                        throw Error('Not a valid bookmark');
                    }
                }
            };
        }]);
})(window.angular, window._);
